import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import {default as handleErrorToast} from "../../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../../components/toast/SuccessToast";
import FinanceDataForm from "../../../domain/FinanceDataForm";
import CustomerOnboardingPanelFeature from "./CustomerOnboardingPanelFeature";

export default class FinanceDataPanelFeature extends CustomerOnboardingPanelFeature {

    constructor(application, generalFeature) {
        super(application, generalFeature);
        this._financeDataForm = null;

        makeObservable(this, {
            _financeDataForm: observable,
            financeDataForm: computed,
            editFinanceData: action,
        })
    }

    async load() {
        this.createFinanceDataForm();
        this.finishLoading();
    }

    createFinanceDataForm() {
        this._financeDataForm = FinanceDataForm.newFor(this.customerOnboarding().request.financeData, this, this.customerOnboarding().configuration);
    }

    async formChanged() {
        await this.editFinanceData()
    }

    async editFinanceData() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                await this.customerOnboardingHasChanged()
                this.createFinanceDataForm();
                handleSuccessToast("Datos guardados correctamente.");
            },
            handlesError: (response) => {
                handleErrorToast("No se pudieron guardar los datos");
            }
        });
        return this._application.apiClient().editFinanceData(this.customerOnboarding().request.taxpayerIdentificationNumber,
            this._financeDataForm.values, responseHandler);
    }

    createForm(){
        return this.createFinanceDataForm()
    }

    get form() {
        return this._financeDataForm;
    }

    get financeDataForm() {
        return this._financeDataForm;
    }

    paymentTermCode() {
        return this.customerOnboarding().request.commercialTerms.paymentTermCode
    }

}
